/**
 * The agent panel's width rules: 400 by default, 360 at the least, and at most
 * 720 or half the window, whichever is smaller. A drag that ends within 24px of
 * 400, 560 or 720 lands on it; Widen / Narrow jump between 400 and 720.
 */
export const PANEL_DEFAULT_WIDTH = 400;
export const PANEL_MIN_WIDTH = 360;
export const PANEL_WIDE_WIDTH = 720;
export const PANEL_SNAPS = [400, 560, 720] as const;
const SNAP_DISTANCE = 24;

/** The widest the panel may be in a window this wide. */
export const panelMaxWidth = (viewport: number): number =>
  Math.max(
    PANEL_MIN_WIDTH,
    Math.min(PANEL_WIDE_WIDTH, Math.floor(viewport / 2))
  );

export const clampPanelWidth = (width: number, viewport: number): number =>
  Math.round(
    Math.min(panelMaxWidth(viewport), Math.max(PANEL_MIN_WIDTH, width))
  );

/** The snap point within reach of `width`, else `width`. */
export const snapPanelWidth = (width: number): number =>
  PANEL_SNAPS.find((s) => Math.abs(s - width) <= SNAP_DISTANCE) ?? width;

/** Whether the window leaves room to widen the panel past its default. */
export const canWidenPanel = (viewport: number): boolean =>
  panelMaxWidth(viewport) > PANEL_DEFAULT_WIDTH;

/** Near the widest the window allows, the header offers Narrow. */
export const isWidePanel = (width: number, viewport: number): boolean =>
  width >= Math.min(640, panelMaxWidth(viewport));

/** Widen goes to 720 (or as wide as the window allows); Narrow back to 400. */
export const toggledPanelWidth = (width: number, viewport: number): number =>
  isWidePanel(width, viewport)
    ? PANEL_DEFAULT_WIDTH
    : clampPanelWidth(PANEL_WIDE_WIDTH, viewport);
